import { getHostName } from '../utils/getEnv';

const defaultHeaders = {
  'FFF-Auth': 'V1.1',
  'Content-Type': 'application/json; charset=utf-8',
};
const hostname = getHostName();

export async function getShippingAddress() {
  try {
    const response = await fetch(`https://user.${hostname}.com/users/shipping-address`, {
      credentials: 'include',
      headers: { ...defaultHeaders },
      body: JSON.stringify({
        activatedOn: true,
      }),
      mode: 'cors',
      method: 'GET',
    });
    return response;
  } catch (_) {
    return null;
  }
}

export async function getFooterContent() {
  try {
    const response = await fetch(`https://asado.${hostname}.com/public/cms/sanity/footer`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData.data;
    }

    return Promise.resolve();
  } catch (err) {
    console.error('error fetching footer content from asado', err);
    return Promise.resolve();
  }
}

export async function getContent(schemaName: string, contentId = 'default') {
  try {
    const response = await fetch(
      `https://content.${hostname}.com/contents/self/${schemaName}/${contentId}`,
      {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (response.ok) {
      const responseData = await response.json();
      return responseData.data;
    }

    return Promise.resolve();
  } catch (err) {
    console.error(`error to obtain schemaName ${schemaName} contentId ${contentId}`, err);
    return Promise.resolve();
  }
}

export async function getSubscriptionPlans() {
  try {
    const response = await fetch(
      `https://localization-api.${hostname}.com/api/1/subscription/plans`,
      {
        credentials: 'include',
        headers: { ...defaultHeaders },
        mode: 'cors',
        method: 'GET',
      },
    );
    if (response.ok) {
      return Promise.resolve(await response.json());
    }

    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
}
